import {
  ActionType,
  SetStatus,
  SetStatusActionStatus,
  SetStatusSnoozePeriod,
} from "@redotech/redo-model/return-flow/action";
import * as React from "react";
import { ActionTypeSetup, RuleTypeDetailsProps } from "./multiple-actions";

export type SetStatusState = {
  status: SetStatusActionStatus;
  snoozePeriod?: SetStatusSnoozePeriod;
};

export const SET_STATUS = (
  Details: React.ComponentType<RuleTypeDetailsProps<SetStatusState>>,
): ActionTypeSetup<SetStatusState, SetStatus> => ({
  name: "Set status",
  description() {
    return "Change the status of the ticket";
  },
  Details(props: RuleTypeDetailsProps<SetStatusState>) {
    return React.createElement(Details, props);
  },
  empty: { status: SetStatusActionStatus.OPEN },
  fromModel(model) {
    return { status: model.status, snoozePeriod: model.snoozePeriod };
  },
  toModel(state) {
    return {
      type: ActionType.SetStatus,
      status: state.status,
      snoozePeriod: state.snoozePeriod,
    };
  },
  valid(state) {
    if (state.status === SetStatusActionStatus.SNOOZED && !state.snoozePeriod) {
      return false;
    }
    return true;
  },
});
